import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22.9997 22.9948C10.4181 22.7322 0.267496 12.5816 0.00488281 0H14.9997C19.4179 0 22.9997 3.58172 22.9997 8V22.9948Z",
      fill: "#00C281"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.99999 10.7562L10.3212 13.0774C10.7172 13.4734 10.9152 13.6714 11.1451 13.7472C11.3474 13.814 11.566 13.8163 11.7697 13.7539C12.0012 13.683 12.2034 13.4892 12.6078 13.1018L18.5033 7.45253",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }